import React from 'react';
import { flexRender, Row } from '@tanstack/react-table';
import { DataNode } from '@/types';
import { Skeleton } from '@/components/ui/skeleton';
import { getRowStyle } from './ReconciliationTable.utils';
import { CUMULATIVE_LOADING_CELLS } from './ReconciliationTable.constants';

interface TableBodyRowProps {
  row: Row<DataNode>;
  index: number;
  isHighlighted: boolean;
  cumulativeLoading?: boolean;
}

/**
 * Component for rendering a single table body row
 */
export const TableBodyRow: React.FC<TableBodyRowProps> = ({
  row,
  index,
  isHighlighted,
  cumulativeLoading = false,
}) => {
  return (
    <tr
      key={row.id}
      className={`${getRowStyle(row.original.NodeTag, row.depth)} transition-all duration-200 dark:hover:from-gray-600 dark:hover:to-gray-600 hover:bg-gradient-to-r hover:from-blue-50/50 hover:to-indigo-50/30 hover:shadow-sm border-b border-modern-light/50 ${
        index % 2 === 0 ? 'bg-white dark:bg-gray-700' : 'bg-slate-50/30 dark:bg-gray-600'
      } ${
        isHighlighted
          ? 'bg-gradient-to-r from-blue-100/60 to-indigo-100/40 border-blue-200 shadow-sm ring-1 ring-blue-300 ring-opacity-30 animate-pulse'
          : ''
      }`}
    >
      {row.getVisibleCells().map((cell) => (
        <td
          key={cell.id}
          className="px-4 py-2 text-sm border-modern-light/30 last:border-r-0"
        >
          {cumulativeLoading && CUMULATIVE_LOADING_CELLS.includes(cell.column.id) ? (
            <div className="flex items-center justify-center">
              <Skeleton className="h-4 w-10" />
            </div>
          ) : (
            flexRender(cell.column.columnDef.cell, cell.getContext())
          )}
        </td>
      ))}
    </tr>
  );
};
